export const ALL_COLUMNS_ID = '*';
